import animateScrollTo from "animated-scroll-to";
import throttle from "raf-throttle";

let scrollRange = Math.round(window.innerHeight / 10);
const iPad = !!(
    navigator.userAgent.match(/(iPad)/) ||
    (navigator.platform === "MacIntel" &&
        typeof navigator.standalone !== "undefined")
);

console.log(scrollRange);

let currentScrollOffset = 0;
let effectCompleted = false;

function getElementContentWidth(element) {
    var styles = window.getComputedStyle(element);
    var padding =
        parseFloat(styles.paddingLeft) + parseFloat(styles.paddingRight);

    return element.clientWidth - padding;
}

Number.prototype.map = function (in_min, in_max, out_min, out_max) {
    const v = Math.max(0.0, this - in_min) / (in_max - in_min);
    let r = out_min + Math.pow(v, 1.111) * (out_max - out_min);
    r = parseFloat(r.toFixed(10));
    return r;
};

export const mainImage = function (el) {
    let imageTone;
    let mediaWidthTarget;
    let mediaHeightTarget;
    let media;
    let mediaWidth;
    let mediaHeight;
    let topBarTreshold;
    let paddingTopTarget;
    let paddingLeftTarget;
    let topBarHeight;

    function updatePosition() {
        currentScrollOffset = window.pageYOffset;
        if (currentScrollOffset < 0) {
            currentScrollOffset = 0;
        }

        if (!effectCompleted) {
            console.log("scrollData", scrollRange, currentScrollOffset);

            let mediaWidthCalculated = currentScrollOffset.map(
                0,
                scrollRange,
                mediaWidth,
                mediaWidthTarget
            );
            let mediaHeightCalculated = currentScrollOffset.map(
                0,
                scrollRange,
                mediaHeight,
                mediaHeightTarget
            );
            let paddingLeftCalculated = currentScrollOffset.map(
                0,
                scrollRange,
                0,
                paddingLeftTarget
            );
            let paddingTopCalculated = currentScrollOffset.map(
                0,
                scrollRange,
                -topBarHeight,
                paddingTopTarget
            );
            let paddingTopCalculatedMedia = currentScrollOffset.map(
                0,
                scrollRange,
                -topBarHeight,
                paddingTopTarget - mediaHeightTarget
            );
            let playbackRate = currentScrollOffset.map(0, scrollRange, 1, 0.1);
            let videoLayerOpacity = currentScrollOffset.map(
                0,
                scrollRange,
                0,
                1
            );
            let videoGreyscale = currentScrollOffset.map(
                0,
                scrollRange,
                0,
                100
            );

            if (mediaWidthCalculated < mediaWidthTarget) {
                mediaWidthCalculated = mediaWidthTarget;
            }
            if (mediaHeightCalculated < mediaHeightTarget) {
                mediaHeightCalculated = mediaHeightTarget;
            }
            if (paddingLeftCalculated > paddingLeftTarget) {
                paddingLeftCalculated = paddingLeftTarget;
            }
            if (paddingTopCalculated > paddingTopTarget) {
                paddingTopCalculated = paddingTopTarget;
            }
            if (
                paddingTopCalculatedMedia >
                paddingTopTarget - mediaHeightTarget
            ) {
                paddingTopCalculatedMedia =
                    paddingTopTarget - mediaHeightTarget;
            }
            if (playbackRate < 0) {
                playbackRate = 0;
            }
            if (videoLayerOpacity > 1) {
                videoLayerOpacity = 1;
            }

            if (videoGreyscale > 100) {
                videoGreyscale = 100;
            }

            el.style.width = mediaWidthCalculated + "px";
            el.style.height = mediaHeightCalculated + "px";
            el.style.marginLeft = paddingLeftCalculated + "px";

            el.style.transform =
                "translateY(" + paddingTopCalculatedMedia + "px)";

            document.querySelector(".page-column--large").style.paddingTop =
                paddingTopCalculated + "px";

            if (currentScrollOffset >= scrollRange) {
                console.log("I'm done!");
                effectCompleted = true;
                if (el.querySelector("video")) {
                    el.querySelector("video").pause();
                    el.querySelector("video").playbackRate = 0;
                }

                el.classList.add("filter");

                el.querySelector("video, img").style.filter =
                    "grayscale(" + videoGreyscale + "%)";
                el.querySelector(".layer").style.opacity = videoLayerOpacity;
            } else {
                if (el.querySelector("video")) {
                    el.querySelector("video").play();
                    el.querySelector("video").playbackRate = playbackRate;
                }
                el.classList.remove("filter");
                el.querySelector("video, img").style.filter =
                    "grayscale(" + videoGreyscale + "%)";
                el.querySelector(".layer").style.opacity = videoLayerOpacity;
            }

            if (imageTone == "dark" && currentScrollOffset >= scrollRange) {
                document
                    .querySelector(".topbar")
                    .classList.remove("topbar--light");
            } else if (
                imageTone == "dark" &&
                currentScrollOffset < scrollRange
            ) {
                document
                    .querySelector(".topbar")
                    .classList.add("topbar--light");
            }
        }
    }

    function init() {
        effectCompleted = false;
        el.setAttribute("style", "");
        imageTone = el.getAttribute("data-image-tone");
        mediaWidthTarget = getElementContentWidth(
            document.querySelector(".page-column--large")
        );
        mediaHeightTarget = mediaWidthTarget / 1.777;

        document.querySelectorAll("main > *").forEach(function (item) {
            if (!item.classList.contains("main-image")) {
                item.style.transform =
                    "translateY(-" + mediaHeightTarget + "px)";
            }
        });
        media = el.getBoundingClientRect();
        mediaWidth = media.width;
        mediaHeight = media.height;
        topBarTreshold = document
            .querySelector(".topbar__inner")
            .getBoundingClientRect();
        topBarHeight = document.querySelector(".topbar").getBoundingClientRect()
            .height;

        const pageColumns = document.querySelector(".page-columns");
        const additionalPaddingLeft =
            document.body.clientWidth > 1600
                ? (document.body.clientWidth - 1600) / 2
                : 0;

        paddingTopTarget =
            mediaHeightTarget +
            parseFloat(window.getComputedStyle(pageColumns).paddingTop);
        paddingLeftTarget =
            parseFloat(
                window.getComputedStyle(document.querySelector(".page-columns"))
                    .paddingLeft
            ) + additionalPaddingLeft;
        scrollRange = Math.round(window.innerHeight / 10);

        if (window.location.hash == "#skip") {
            document.body.style.opacity = 0;
            document.documentElement.scrollTop = scrollRange;
            updatePosition();
            effectCompleted = true;
            console.log("Move to scrollrange -> ready");
            setTimeout(function () {
                document.documentElement.scrollTop = 0;
                document.body.style.opacity = 1;
                console.log("To top");
            }, 100);
        } else {
            updatePosition();
        }
    }

    const throttled = throttle(updatePosition);

    window.addEventListener("scroll", throttled);
    if (window.innerWidth > 1023 && !iPad) {
        window.addEventListener("resize", init);
    }
    window.addEventListener("load", init);

    init();
};

export const mainImageClick = function (el) {
    if (currentScrollOffset < scrollRange && !effectCompleted) {
        animateScrollTo(scrollRange, {
            easing: (t) => (t < 0.5 ? 2 * t * t : -1 + (4 - 2 * t) * t),
            minDuration: 500,
            speed: 500,
            verticalOffset: 0,
        });
    } else {
        console.log("Initial call");
        animateScrollTo(scrollRange - 1, {
            easing: (t) => (t < 0.5 ? 2 * t * t : -1 + (4 - 2 * t) * t),
            speed: 500,
            verticalOffset: 0,
        }).then((hasScrolledToPosition) => {
            console.log("back to zero");
            effectCompleted = false;
            setTimeout(function () {
                animateScrollTo(0, {
                    easing: (t) => (t < 0.5 ? 2 * t * t : -1 + (4 - 2 * t) * t),
                    minDuration: 500,
                    speed: 500,
                    verticalOffset: 0,
                });
            }, 10);
        });
    }
};
